/* eslint-disable max-lines-per-function */
import { useCallback } from 'react';

import { Modal, ModalWidth } from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';
import { GenerateZD3Form } from '../forms/GenerateZD3Form';
import { GenerateZD3FormLoader } from '../forms/GenerateZD3Form.loader';
import { GenerateZD3StatisticsButton } from '../forms/buttons/GenerateZD3StatisticsButton';

import { GenerateStatisticsModalButtons } from './GenerateStatisticsModalButtons';
import { handleStatisticsRefetch } from './GenerateStatisticsModal.utils';

type GenerateZD3StatisticsModalProps = {
   readonly closeModal: VoidFunction;
};

export const GenerateZD3StatisticsModal = (props: GenerateZD3StatisticsModalProps): JSX.Element => {
   const handleOnSuccess = useCallback(() => {
      handleStatisticsRefetch(props.closeModal);
   }, [props.closeModal]);

   return (
      <Modal
         title={statisticsTranslationKeys.modal.title}
         onCloseRequest={props.closeModal}
         animateVisibility
         width={ModalWidth.NORMAL}
         testId={'generateZD3StatisticsModal'}
         visible
      >
         <GenerateZD3FormLoader>
            {({ healthcareFacilityUnits }) => (
               <GenerateZD3Form healthcareFacilityUnits={healthcareFacilityUnits}>
                  {({ handleSubmit, formState }) => (
                     <>
                        <GenerateZD3StatisticsButton handleSubmit={handleSubmit} onSuccess={handleOnSuccess} />
                        <GenerateStatisticsModalButtons
                           handleClose={props.closeModal}
                           shouldConfirmExit={formState.isDirty}
                        />
                     </>
                  )}
               </GenerateZD3Form>
            )}
         </GenerateZD3FormLoader>
      </Modal>
   );
};
